export default __webpack_public_path__ + "static/media/icons.c4197426.ttf";